<tax-page-header titleText="users.title" [rightSide]="addUserButton"></tax-page-header>
<ng-template #addUserButton>
  <a class="like-button" data-qa-link="create-user" [routerLink]="'0'" translate>groups.add</a>
</ng-template>

<tax-input
  placeholder="users.search.placeholder"
  [formControl]="usernameControl"
  [autofocus]="true"
  [clearable]="true"
  data-qa-input="search-user"
></tax-input>

<div class="filter-list" data-qa-block="filter">
  <div class="filter">
    <tax-search-dropdown-list
      [data]="retailPlaces.items$ | async"
      [currentItem]="retailPlaces.defaultItem.title"
      (submittedData)="selectedRetailPlaceChanged$.next($event.id)"
      data-qa-select="retail-places"
    ></tax-search-dropdown-list>
  </div>
  <div class="filter">
    <tax-search-dropdown-list
      [data]="groups.items$ | async"
      [currentItem]="groups.defaultItem.title"
      (submittedData)="selectedGroupChanged$.next($event.id)"
      data-qa-select="groups"
    ></tax-search-dropdown-list>
  </div>
</div>

<ng-container *ngIf="users$ | async as users">
  <div class="ui-kit-rows-layout" data-qa-block="users-list">
    <div
      *ngFor="let user of users; trackBy: trackById"
      [routerLink]="[user.id]"
      class="user ui-kit-item-container"
      data-qa="user"
      data-qa-link="user-page"
    >
      <div class="user-main-info">
        <div class="user-name" data-qa="user-name">{{ user.name }}</div>
        <div class="user-login" data-qa="user-login">{{ user.login }}</div>
      </div>
      <div class="user-description">
        <div data-qa="user-groups">{{ user.groupsName }}</div>
        <div *ngIf="user.lastActionDate" data-qa="user-last-action-date">
          {{ user.lastActionDate | dateTime: { withSeconds: true } }}
        </div>
      </div>
    </div>
  </div>

  <tax-empty-list *ngIf="users.length === 0" text="user.empty.list"></tax-empty-list>
</ng-container>
